import { FormValue } from './types';

/**
 * Converts a date string in MM/YYYY format to ISO date string format (YYYY-MM-DD).
 */
export const convertDateToString = (value: FormValue): string | undefined => {
  try {
    if (typeof value !== 'string') return undefined;

    const [month, year] = value.split('/');
    const yearNum = parseInt(year);

    if (yearNum < 1950 || yearNum > 2050) {
      return undefined;
    }

    const date = new Date(yearNum, parseInt(month) - 1, 1);

    return date.toISOString().split('T')[0];
  } catch {
    return undefined;
  }
};

/**
 * Converts an ISO date string (YYYY-MM-DD) to MM/YYYY format.
 *
 */
export const convertDateFromString = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1; // getMonth() is 0-indexed
  const year = date.getFullYear();

  return `${month.toString().padStart(2, '0')}/${year}`;
};

export const convertStringValue = (value: FormValue): string => {
  return typeof value === 'string' ? value : String(value);
};

export const convertBooleanValue = (value: FormValue): boolean => {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'yes';
  }

  return Boolean(value);
};
